import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_SUBMITTALS} from "../actions/submittals";

/*
Structure of submittals model:

{
  data: {
    [uuid]: {
      permissions: {
        // these are returned by the backend; may not be up to date
        view: bool
        update: bool
        delete: bool
      }
      resource: {
        // these are returned by the backend; may not be up to date
        id: string // uuid
        projectid: string // uuid
        createdbyuserid: string // uuid
        owneruserid: string // uuid
        createdbycompanyid: string // uuid
        ownercompanyid: string // uuid
        datecreated: datetime
        reply: string
        replydate: date
        number: string
        title: string
        description: string
        belongsto: string // uuid
        status: string // code-drive code_submittalstatus
        duedate: date
        csicodes: array of string // code-driven code_csi
        active: bool
      }
    }
  }
  indexes: {
    // used for indexing entries by different fields other than the id field
    projectid: {
      [projectid]:
        [submittalid]: dontcare
    }
  }

}
 */

const submittalInitial = {
  data: {},
  indexes: {
    projectid: {}
  },
};

const submittalsReducer = createReducer(submittalInitial,
  {
    [ADD_SUBMITTALS]: (state, action) => {
      let newState = state;
      action.payload.forEach(item => {
        newState = R.over(R.lensPath(['data', item.resource.id]), () => item)(newState);
        newState = R.over(R.lensPath(['indexes', 'projectid', item.resource.projectid]), value => {
          if (!value) {
            return {[item.resource.id]: 1};
          } else {
            return {...value, [item.resource.id]: 1};
          }
        })(newState);
      });
      return newState;
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default submittalsReducer;



// WEBPACK FOOTER //
// ./src/reducers/submittals.js